<template>
  <v-chip :color="getTypeColor(status.name)" text-color="white" label>
    {{ status.text }}
  </v-chip>
</template>

<script>
export default {
  name: 'UserStatus',
  props: {
    status: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getTypeColor(name) {
      let color = 'default'

      switch (name) {
        case 'ACTIVE':
          color = '#4caf50'
          break

        case 'PENDING_VERIFY':
          color = '#ff9800'
          break

        case 'PENDING_VERIFY_ADMIN':
          color = '#f44336'
          break

        case 'PENDING_DELETE_ADMIN':
          color = '#78909c'
          break

        default:
          color = 'default'
      }

      return color
    },
  },
}
</script>
